const GAPI_KEY = 'AIzaSyCSoqF056KFNqFsYQgynT05Q5h2GFIrZcI';

// Array of API discovery doc URLs for APIs
const GAPI_DISCOVERY_DOCS = [
  'https://sheets.googleapis.com/$discovery/rest?version=v4',
];

// Authorization scopes required by the API; multiple scopes can be
// included, separated by spaces.
const GAPI_SCOPES = [
  'https://www.googleapis.com/auth/spreadsheets',
];

const GID = '710892852811-g5i7v3rfcgps3d7nhv2ut10v85g9e9ha.apps.googleusercontent.com';

/**
 * Returns the domain name to use for environment-specific
 * operations. Usually, this is the same as the domain name
 * hosting the site. However, it can be overridden by
 * specifying the `domain` on the `DASH` window object.
 *
 * If running on `localhost` in development and no override
 * is specified, it will default to the `wiwdatadevel.com`
 * domain.
 *
 * @return {string}
 */
function getDomainName() {
  const { host } = window.location;
  if (window.FINANCE.domainOverride) {
    return window.FINANCE.domainOverride;
  }

  return host.startsWith('localhost')
    ? 'wiwdatadevel.com'
    : window.location.host.split('.').slice(-2).join('.');
}

/**
 * Returns the API endpoint root for communicating with the backend. The
 * backend depends upon the current domain using the `getDomainName()`
 * function unless the `endpoint` is specified explicitly on the `DASH`
 * window object.
 *
 * @return {string}
 */
function getEndpoint() {
  const mode = window.FINANCE.modeOverride || window.FINANCE.BUILD_MODE;
  return window.FINANCE.endpointOverride || `https://finance-api.${getDomainName()}/${mode}`;
}

/**
 * Returns a string representing the current environment
 * @returns {string}
 */
export function getEnvironment() {
  const domain = getDomainName();
  if (domain.search('wiwdata.com') !== -1) {
    return 'prod';
  }

  if (domain.search('wiwdatastage.com') !== -1) {
    return 'stage';
  }

  return 'devel';
}

/**
 * Returns true if environment is production
 * @returns {boolean}
 */
export function isProduction() {
  return getEnvironment() === 'prod';
}

/**
 * Return the URI for superset transactions dashboard in the same environment as finance portal.
 * @return {string}
 */
export function getTransactionsDashboardUri() {
  switch (getEnvironment()) {
    case 'prod':
      return 'https://superportal.wiwdata.com/superset/dashboard/170';
    case 'stage':
      return 'https://superportal.wiwdatastage.com/superset/dashboard/1';
    case 'devel':
      return 'https://superportal.wiwdatadevel.com/superset/dashboard/34';
    default:
      throw new Error('Unknown environment');
  }
}

// Products object to be used in tags and in the transactions table
const PRODUCT_LINES = [
  {
    id: 'scheduling',
    name: 'Scheduling',
    abbreviation: 'S',
    bitId: 0b001,
    classes: { scheduling_tag: true, 'is-small': true },
    backGroundColor: '#7edc63',
    style: 'background-color: #7edc63; color: #000000; padding-right: 7px; padding-left: 7px',
  },
  {
    id: 'attendance',
    name: 'Attendance',
    abbreviation: 'A',
    bitId: 0b010,
    classes: { attendance_tag: true, 'is-small': true },
    backGroundColor: '#bddffd',
    style: 'background-color: #bddffd; color: #000000; padding-right: 7px; padding-left: 7px',
  },
  {
    id: 'hire',
    name: 'Hire',
    abbreviation: 'H',
    bitId: 0b100,
    classes: { hire_tag: true, 'is-small': true },
    backGroundColor: '#b7b7ff',
    style: 'background-color: #b7b7ff; color: #000000; padding-right: 7px; padding-left: 7px',
  },
];

// The API access options to be used with the VerticalCheckBoxInput component.
const API_KEYS_ACCESS_OPTIONS = [
  {
    label: 'Read',
    value: 'read',
  },
  {
    label: 'Write',
    value: 'write',
  },
  {
    label: 'Account',
    value: 'account',
    tooltip: 'Allows API Key to create new accounts',
  },
  {
    label: 'Coupons',
    value: 'coupons',
    tooltip: 'Allows API Key to create coupons',
  },
];

export default {
  GAPI_SCOPES,
  GAPI_DISCOVERY_DOCS,
  GAPI_KEY,
  GID,
  PRODUCT_LINES,
  API_KEYS_ACCESS_OPTIONS,
  getEndpoint,
  getDomainName,
  isProduction,
};
